import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { mailRoutes } from 'routes';
import { getDefaultRoute } from 'services/common';
import { getProjectsFromServer } from 'store/actions/projects';
import { getCategoriesFromServer } from 'store/actions/categories';
import { getTemplatesFromServer } from 'store/actions/templates';
import { getAllWebhooksFromServer } from 'store/actions/webhooks';
import { getApiKeysFromServer } from 'store/actions/apiKeys';
import DefaultView from 'components/ui/DefaultView';
import PageNotFound from 'containers/PageNotFound/PageNotFound';
import AuthorizeGmailAccountSuccess from './Gmail/AuthorizeGmailAccountSuccess';
import {
  fetchGmailAccounts,
  getEmailTypesFromServer,
} from 'store/actions/emails';
import AppRoute from 'components/AppRoute';

const { component: DefaultComponent } = getDefaultRoute(mailRoutes);

class Mail extends Component {
  componentDidMount() {
    this.loadData();
  }

  loadData = () => {
    this.props.onGetProjects();
    this.props.onGetCategories();
    this.props.onGetApiKeys();
    this.props.onGetAllWebhooks();
    this.props.onGetEmailTypes();
    this.props.onGetTemplates();
    this.props.onGetGmailAccounts();
  };

  render() {
    return (
      <DefaultView appTitle="ECS">
        <Switch>
          <AppRoute
            component={DefaultComponent}
            exact
            path="/mail"
            permission="mail.projects.view"
          />
          <Route
            component={AuthorizeGmailAccountSuccess}
            exact
            path={'/mail/gmail/success'}
          />
          {mailRoutes.map(({ component, path, permission }) => (
            <AppRoute
              component={component}
              key={path}
              path={path}
              permission={permission}
            />
          ))}
          <Route component={PageNotFound} />
        </Switch>
      </DefaultView>
    );
  }
}

Mail.propTypes = {
  onGetAllWebhooks: PropTypes.func.isRequired,
  onGetApiKeys: PropTypes.func.isRequired,
  onGetCategories: PropTypes.func.isRequired,
  onGetEmailTypes: PropTypes.func.isRequired,
  onGetProjects: PropTypes.func.isRequired,
  onGetTemplates: PropTypes.func.isRequired,
};

const actions = {
  onGetApiKeys: getApiKeysFromServer,
  onGetProjects: getProjectsFromServer,
  onGetCategories: getCategoriesFromServer,
  onGetTemplates: getTemplatesFromServer,
  onGetAllWebhooks: getAllWebhooksFromServer,
  onGetEmailTypes: getEmailTypesFromServer,
  onGetGmailAccounts: fetchGmailAccounts,
};

export default connect(
  null,
  actions,
)(Mail);
